import { createFileRoute } from '@tanstack/react-router';
import MediaPageComponent from 'src/Administration/PageContent/PageContentMediaPage/PageContentMediaPage';

export const Route = createFileRoute('/systemadmin/_layout/page-content/media-page')({
  component: MediaPageComponent,
});
